import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import { getHumanLabelBathrooms, getHumanLabelBedrooms } from '../../../../../helpers/line'

const SingleSlideMarquee = ({ line }) => {
  const [marqueeWidth, setMarqueeWidth] = useState(0)
  const textRef = useRef(null)
  const [textWidth, setTextWidth] = useState(0)
  const nameRef = useRef()
  useEffect(() => {
    if (textRef.current && nameRef.current) {
      setMarqueeWidth(document.body.clientWidth - nameRef.current.clientWidth - 48 - 16)
      // Measure the full width of the text
      setTextWidth(textRef.current.scrollWidth) // Use scrollWidth for accurate measurement
    }
  }, [])

  // Calculate how much text overflows beyond the container width
  const overflowWidth = textWidth > marqueeWidth ? textWidth - marqueeWidth + 5 : 0 // Add a 5px buffer for safety

  return (
    <>
      <span className="flex-shrink-0" ref={nameRef}>
        {line.label}
      </span>
      <div
        className='ml-[16px]'
        style={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: `${marqueeWidth}px`,
          display: 'flex',
          justifyContent: overflowWidth > 0 ? 'flex-start' : 'flex-end', // Align to right if text fits, otherwise start from left
        }}
      >
        <motion.div
          ref={textRef}
          initial={{ x: 0 }} // Start at 0
          animate={{ x: -overflowWidth }} // Slide left by the calculated overflow amount
          transition={{ duration: 5, ease: 'linear', delay: 2 }} // Add delay before starting the animation
          style={{
            display: 'inline-block',
            paddingRight: overflowWidth > 0 ? '5px' : '0px', // Add extra padding when there's an overflow
          }}
        >
          <span className="text-[#3D4256] opacity-40 ml-[16px]">
            {[getHumanLabelBedrooms(line.data), getHumanLabelBathrooms(line.data)].join(' · ')}
            {line.data.size_to_display ? ` · ${line.data.size_to_display} ft sq` : ''}
          </span>
        </motion.div>
      </div>
    </>
  )
}

export default SingleSlideMarquee
